module.exports = __webpack_public_path__ + "img/workflow-orchestration.d7b6888c.png";